export default "__VITE_ASSET__CO1a_GTu__"